import axios from "axios";
import { wmSign, wmAes, wm_aes_for_web } from "../../apiFunc/encrypt";
import { GetTimeStamp } from "../../apiFunc/getDate";

const appURL = `${process.env.REACT_APP_APP_URL}/api`;
const oauthURL = `${process.env.REACT_APP_OAUTH_URL}/api`;
const appId = process.env.REACT_APP_ID;
const deviceUuid = process.env.REACT_APP_DEVICE_UUID;

const header = {
  "Content-Type": "application/json",
  "Accept-Language": "zh-TW",
  "app-id": appId,
  "device-uuid": deviceUuid,
};

async function EncryptRelay({ thirdPartyUrl, thirdPartyPayload }) {
  const body = {
    request_parameter: {
      url: thirdPartyUrl,
      payload: wmAes(JSON.stringify(thirdPartyPayload)),
    },
    timestamp: GetTimeStamp(),
  };
  const sign = wmSign(body);
  const data = {
    sign: sign,
  };
  const response = await axios.post(`${appURL}/function/encrypt_relay`, data, {
    headers: header,
    request_body_type: "x-www-form-urlencoded",
    merchant: "HTY",
  });
  return response.data;
}

export { EncryptRelay };
